module.exports = __webpack_public_path__ + "img/red.ebc2ed0.webp";